import {
    IComparisonBoardFilters,
} from '../../../../interfaces/comparison-boards/IComparisonBoards';

const selectClassName = 'w-full rounded-xl border bg-white dark:bg-black px-3 py-2 text-sm text-black dark:text-white border-gray-200 dark:border-borderColor-darkMode focus:outline-none focus:border-gray-300 dark:focus:border-gray-600';

const SearchIcon = () => (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
        <path
            d='M21 21l-4.35-4.35M10.8 18a7.2 7.2 0 1 1 0-14.4 7.2 7.2 0 0 1 0 14.4Z'
            stroke='currentColor'
            strokeWidth='1.8'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

const ComparisonBoardFilters = ({
    totalElements,
    filters,
    loading,
    onChange,
    onClear,
}: {
    totalElements: number;
    filters: IComparisonBoardFilters;
    loading?: boolean;
    onChange: (next: IComparisonBoardFilters) => void;
    onClear: () => void;
}) => {
    const onActiveChange = (value: string) => {
        const nextFilters = { ...filters };
        if (value === '') {
            delete nextFilters.active;
        } else {
            nextFilters.active = value === 'true';
        }
        onChange(nextFilters);
    };

    return (
        <div className='rounded-xl border border-gray-200 dark:border-borderColor-darkMode bg-white dark:bg-black px-3 py-3 my-3'>
            <div className='flex flex-col gap-1 md:flex-row md:items-center md:justify-between'>
                <h4 className='text-sm font-semibold dark:text-primary-darkMode'>
                    Showing {totalElements} comparison boards
                </h4>
            </div>

            <div className='mt-3 flex flex-col gap-2 xl:flex-row xl:flex-wrap xl:items-end'>
                <div className='relative w-full xl:max-w-[380px]'>
                    <span className='absolute left-4 top-1/2 -translate-y-1/2 text-gray-400'>
                        <SearchIcon />
                    </span>
                    <input
                        value={filters.search || ''}
                        onChange={(event) =>
                            onChange({
                                ...filters,
                                search: event.target.value,
                            })}
                        placeholder='Search main or cloned account'
                        className='w-full rounded-xl border bg-white dark:bg-black pl-10 pr-3 py-2 text-sm text-black dark:text-white border-gray-200 dark:border-borderColor-darkMode focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-gray-300 dark:focus:border-gray-600'
                    />
                </div>

                <div className='relative w-full xl:w-[220px]'>
                    <label className='mb-1 block text-[11px] font-medium text-gray-500 dark:text-gray-300'>
                        Active
                    </label>
                    <select
                        value={typeof filters.active === 'boolean' ? String(filters.active) : ''}
                        onChange={(event) => onActiveChange(event.target.value)}
                        className={selectClassName}
                    >
                        <option value=''>All</option>
                        <option value='true'>Yes</option>
                        <option value='false'>No</option>
                    </select>
                </div>

                <div className='flex flex-col gap-2 sm:flex-row'>
                    <button
                        type='button'
                        onClick={onClear}
                        disabled={loading}
                        className='rounded-xl border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 dark:border-borderColor-darkMode dark:text-primary-darkMode hover:bg-gray-50 dark:hover:bg-bgColor-darkMode disabled:opacity-50'
                    >
                        Clear
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ComparisonBoardFilters;
